/* --------------------------------------------------------------------------------------
   calendarPopup.component.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const calendarPopupComponent = {
  template: `
  <div id="calendar" xw-popup display="vm.display" title="{{vm.title}}" on-close="vm.closed()" on-cancel="vm.closed()">
    <xda-calendar date="vm.date" min-date="vm.minDate" max-date="vm.maxDate"></xda-calendar>
  </div>
  `,
  controllerAs: 'vm',
  bindings: {
    display: '=',
    title: '@',
    minDate: '<',
    maxDate: '<',
    date: '=',
    closed: '&',
    cancel: '&'
  },
  controller: class calendarPopupController {
    /*@ngInject*/
    constructor(commonService) {
      this.commonService = commonService
    }
    $onInit() {
      //this.tmpdate = angular.copy(this.date)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/calendarPopup.component.js